import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrandSearchHeader } from './brand-search-header';
import Loading from '../../../../app/main/customers/customersList/loading';
import { TableView } from '../../../infra/ui/table/table-default';
export var BrandList = function (_a) {
    var table = _a.table, isLoading = _a.isLoading, searchTerm = _a.searchTerm, onSearchChange = _a.onSearchChange;
    return (_jsxs("div", { children: [_jsx(BrandSearchHeader, { searchTerm: searchTerm, onSearchChange: onSearchChange }), _jsxs("div", { className: "c-wrapper o-page-height", children: [isLoading && _jsx(Loading, {}), !isLoading && _jsx(TableView, { table: table })] })] }));
};
